import { createTheme } from '@mui/material/styles';

export default function get_main_theme(mode='light') {
    return createTheme({
        palette: {
            mode,
            background: {
                ...(mode === 'light'
                    ? {
                        default: '#D3E0FF',
                        paper: '#fff',
                        table: '#fff'
                    }
                    : {
                        default: '#212121',
                        paper: '#0E0E0E',
                        table: '#7E7E7E'
                    })
            },
            text: {
                ...(mode === 'light'
                    ? {
                        primary: '#000',
                    }
                    : {
                        primary: '#fff',
                    }),
            }
        }
    })
}
